module.exports = __webpack_public_path__ + "static/media/8H.58cd81d9.svg";